module.exports = __webpack_public_path__ + "4b46a0d055052d039863d0d11e9e4738.svg";